/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { themeV2, pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils
import { hoverTransition } from '../../../utils/styles/general';



/* ++++++++++ --------------- EXPANDABLE SECTION - SECTION CARD : STYLES --------------- ++++++++++ */
export default theme => ({
  sectioncard: {
    width: '100%',
    background: 'rgb(255, 255, 255)',
    borderRadius: pxToEm(12),
    border: replacePXinStringWithEM(`1px solid ${themeV2.color.base.gray.button}`),
    // boxShadow: replacePXinStringWithEM('0px 1px 1px 0px rgb(237, 241, 250)'),
    padding: replacePXinStringWithEM('42px 32px'),
    marginBottom: pxToEm(16),
    extend: hoverTransition(),
    '&:hover': {
        border: replacePXinStringWithEM(`1px solid ${themeV2.color.base.gray.light}`),
        // boxShadow: replacePXinStringWithEM('1px 2px 2px 1px rgb(224, 229, 241)'),
    },
    '& h4': {
      color: themeV2.color.base.gray.dark
    }
  }
});
